import {
  each,
  filter,
  remove,
  findIndex
} from 'lodash';
import app from '../../angular_app.es6';

app.controller('ConfigConceptsTestController', [ '$scope', 'Notification', '$timeout', '$http', '$element', '$interval', '$rootScope',
  ($scope, Notification, $timeout, $http, $element, $interval, $rootScope) => {
    $scope.form = {};
    $scope.source_form = {};
    $scope.options = {};
    $scope.checkInterval = 5000;
    $scope.checkEvery5s = null;

    $scope.init = (data, options, notification) => {
      $scope.form = angular.copy(data);
      $scope.source_form = data;
      $scope.form.express_images = $scope.form.express_images || [];
      $scope.options = options;
      $scope.notification = notification;
      $scope.asyncGenerateJID = $scope.options.jid;
      $scope.maxConcepts = $scope.options.max_concepts;

      if ($scope.asyncGenerateJID) {
        $scope.checkEvery5s = $interval($scope.checkAsyncGenerate, $scope.checkInterval);
        $rootScope.$broadcast('disableNavButtons');
      }

      if ($scope.notification) {Notification.error($scope.notification);}
    };

    $scope.maxToUpload = () => (Math.abs($scope.goodImages().length - $scope.maxConcepts));

    $scope.$watch('form.concepts_mode', (newValue) => {
      $scope.form.min = (newValue === 'sequential' ? 2 : 1);
    }, true);

    $scope.openUploader = (event, parentPath, path) => {
      event.preventDefault();

      $(event.target).parents(parentPath).find(path).click();
    };

    $scope.showImage = (image) => {
      return !image._destroy;
    };

    $scope.isGoodImage = (el) => { return !!el.image_src && el.image_src != '#' && !el._destroy; };

    $scope.goodImages = () => {
      return filter($scope.form.express_images, (i) => { return $scope.isGoodImage(i); });
    };

    $scope.editImage = (image) => {
      each($scope.form.express_images, (b) => { b.editing = false; });
      image.editing = true;
    };

    $scope.setImage = (url) => {
      const style = {};
      if (!!url && url != '#') {style['background-image'] = `url(${url})`;}
      return style;
    };

    $scope.destroyImage = (image) => {
      if (image.id) {image._destroy = true;} else {remove($scope.form.express_images, image);}
    };

    $scope.sourceGenerator = () => {
      return {
        id: null,
        image_src: '#'
      };
    };

    $scope.removeExtension = (filename) => {
      return (filename || '').split('.').slice(0, -1).join('.');
    };

    $scope.onImageUploaded = (image) => {
      if (!image.onImageUploaded) {
        image.onImageUploaded = (source) => {
          const source_json = JSON.parse(source['source_data']);
          if (source_json.metadata.mime_type == "application/pdf") {
            $http.post('/express/api/transformer', { project_id: $scope.form.id, source_data: source['source_data'] }).then(
              (response) => {
                watchConvertStatus(source, response.data.jid);
              },
              (response) => {
                Notification.error(response.data.error || response.statusText);
                $scope.destroyObject(null, source);
              }
            );
          } else {
            source['image_data'] = source['source_data'];
            source['image_src'] = source['preview_src'];
            Object.merge(source, { loading: false });
          }
        };
      }
      return image.onImageUploaded;
    };

    $scope.onUploadSuccess = (source) => {
      const source_json = JSON.parse(source['source_data']);
      source['name'] = $scope.removeExtension(source_json.metadata.filename);

      if (source_json.metadata.mime_type == "application/pdf") {
        $http.post('/express/api/transformer', { project_id: $scope.form.id, source_data: source['source_data'] }).then(
          (response) => {
            watchConvertStatus(source, response.data.jid);
          },
          (response) => {
            Notification.error(response.data.error || response.statusText);
            $scope.destroyImage(source);
          }
        );
      } else {
        source['image_data'] = source['source_data'];
        source['image_src'] = source['preview_src'];
        Object.merge(source, { loading: false });
      }
    };

    $scope.filesToUploadArray = () => {
      const filesToUpload = filter(($scope.form.express_images || []), (img) => {
        return img.loading && img.id === null;
      }).length;
      let size = Math.min.call(0, filesToUpload);
      if (size < 0) {size = 0;}
      return [].constructor(size);
    };

    $scope.isLoading = () => {
      return findIndex(($scope.form.express_images || []), (img) => { return img.loading; }) > -1;
    };

    $scope.onImageSelected = (image) => {
      return function (file) {
        image.loading = true;
      };
    };

    $scope.emptyListConcepts = () => {
      const letEmptyListConcepts = ($scope.goodImages().length == 0) && ($scope.filesToUploadArray().length == 0);
      if (letEmptyListConcepts) {$rootScope.$broadcast('hideExamples');} else {$rootScope.$broadcast('showExamples');}
      return letEmptyListConcepts;
    };

    $scope.resizeTextArea = (e) => {
    //let offset = e.target.offsetHeight - e.target.clientHeight;
    //set height to auto to define scrollHeight when height is decrease
      const el = e.target;
      if (el) {
        el.style.height = `${el.scrollHeight}px`;
      }
    };

    // private

    const watchConvertStatus = (source, jid) => {
      (function tick() {
        $http.get(`/express/api/transformer/${jid}`).then(
          (response) => {
            const state = response.data.state;
            if (response.data.status == 'failed') {
              state.step = 'error';
              state.message = `Something went wrong while processing the '${source.name}' at the moment, please try again`;
            }

            switch (state.step) {
              case 'finished':
                Object.merge(source, state.output);
                Object.merge(source, { loading: false });
                break;
              case 'error':
                $scope.destroyImage(source);
                Notification.error(state.message);
                break;
              default:
                $timeout(tick, 3000);
            }
          },
          (response) => {
            Notification.error(response.data.error || response.statusText);
          }
        );
      })();
    };


    $scope.checkAsyncGenerate = () => {
      $http.get($scope.options.check_status_url).then(
        (success) => {
          if (success.data.status == "finished") {
            $interval.cancel($scope.checkEvery5s);
            $scope.asyncGenerateJID = null;
            window.location.href = $scope.options.next_step_url;
          } else if (success.data.status == "failed") {
            $scope.asyncGenerateJID = null;
            $interval.cancel($scope.checkEvery5s);
            Notification.error("Project rebuilding failed.");
            $rootScope.$broadcast('enableNavButtons');
          }
        },
        (reject) => {
          $interval.cancel($scope.checkEvery5s);
          $scope.asyncGenerateJID = null;
          console.log('checkAsyncGenerate', reject);
          $rootScope.$broadcast('enableNavButtons');
        }
      );
    };

    $scope.$watch('isLoading()', (newVal) => {
      if (!$scope.asyncGenerateJID) {
        if (newVal) {
          $rootScope.$broadcast('disableNavButtons');
        } else {
          $rootScope.$broadcast('enableNavButtons');
        }
      }
    });

    $scope.$on('project-form-next-step', (event) => {
      if ($scope.asyncGenerateJID) {
        event.preventDefault();
        Notification.error("Rebuilding in progress.");
        return;
      }

      if ($scope.isLoading()) {
        event.preventDefault();
        Notification.error("Uploading in progress.");
        return;
      }

      const form = $('#config_form');

      if (!$scope.options.need_generate) {
        form.submit();
      } else if (!trackChanges() && trackExisting() && !$scope.notification) {
        event.preventDefault();
        window.location.href = $scope.options.next_step_url;
      } else if (!trackExisting()) {
        form.submit();
      } else if (confirm($scope.options.change_structure_message)) {
        form.submit();
      }
    });

    const trackExisting = () => {
      return !!filter($scope.form.express_images, (el) => !!el.id).length;
    };

    function trackChanges() {
      return !angular.equals($scope.form, $scope.source_form);
    }
  } ]);
